/** Display only: the clipboard must receive the original, complete URL. */
export function truncateCalendarUrl(url: string, maxLength = 34): string {
  const display = url.replace(/^https?:\/\//, '');
  const limit = Math.max(1, Math.floor(maxLength));
  return display.length <= limit ? display : `${display.slice(0, limit - 1)}…`;
}

export function taskTemplateCountLabel(count: number): string {
  return `${count} task${count === 1 ? '' : 's'}`;
}
